import React, { Component } from 'react';
import EnhancedTable from '../../components/dataTableCity';
import { Card, CardHeader, CardBody } from 'reactstrap';
import exportlistImg from '../../../src/assets/fontawesome/csv.png';
import { Helmet } from 'react-helmet';
import { decodeforspace } from '../../utils/helper';
import AppContext from '../../AppContext';
import LazyLoad from 'react-lazyload';
import Postman from '../../utils/service';
import { Link } from 'react-router-dom'

// const fetch = require('node-fetch');

// const env = process.env.NODE_ENV || 'development';
// const config = require('../../config.json')[env];
// const admin_url = config.admin_url;

class Home extends Component {
  constructor(props) {
    super(props);
    const city = decodeforspace(props.match.params.city);
    const year = new Date().getFullYear();

    this.state = {
      order: 'asc',
      orderBy: 'cityRanking',
      modalIsOpen: false,
      city,
      year: year,
      header: `100 Fastest Growing Companies in ${city} ${year}: Top Startups`,
      title: `100 Fastest Growing Companies in ${city} ${year}: Top Startups`,
      cityPageData: {},
      cityName: '',
    };
  }
  selectCompany = (company, id) => {
    this.props.history.push(`/company/${company}`);
  }


  componentDidMount() {
    const { city } = this.props.match.params;
    if (city != this.state.cityName) {
      let decodedCity = decodeforspace(city);
      this.setState({ cityName: decodedCity });
      this.getData(decodedCity);
    }
  }


  componentWillReceiveProps(nextprops) {
    const { city } = nextprops.match.params;
    if (city != this.props.city) {
      let decodedCity = decodeforspace(city);
      this.setState({ cityName: decodedCity, city: decodedCity });
      this.getData(decodedCity);
    }
  }

  getCityData = (data) => {
    // if (data.header) {
    //   this.setState({ header: data.header })
    // }
    // if (data.title) {
    //   this.setState({ title: data.title })
    // }

  }

  getData = (city) => {
    Postman.getCityPage(city)
      .then(res => {
        this.setState({ cityPageData: res.data.citypage });
        if (res.data.citypage && res.data.citypage.header) {
          this.setState({ header: res.data.citypage.header });
        } else {
          this.setState({ header: `100 Fastest Growing Companies in ${city} ${this.state.year}: Top Startups` });
        }
        if (res.data.citypage && res.data.citypage.title) {
          this.setState({ title: res.data.citypage.title });
        } else {
          this.setState({ title: `100 Fastest Growing Companies in ${city} ${this.state.year}: Top Startups` });
        }
      }).catch(err => {
        console.log('err', err);
      });
  }

  render() {
    const header = this.context && this.context.cityPage && this.context.cityPage.header && this.state.city == this.context.cityPage.City ? this.context.cityPage.header : this.state.header;
    const title = this.context && this.context.cityPage && this.context.cityPage.title && this.state.city == this.context.cityPage.City ? this.context.cityPage.title : this.state.title;
    const { city } = this.state;

    return (
      <div className="animated fadeIn" style={{ height: '100%' }}>
        <Helmet>
          <title>{title}</title>
          <meta name="description" content={title} />
          <meta name="author" content="Growjo" />
        </Helmet>
        <Card style={{ height: '100%', marginBottom: 0 }}>
          <CardHeader style={{ backgroundColor: 'white' }}>
            <div>
              <h1 style={{ color: '#474866', fontSize: 22, marginBottom: 0 }}>{header}</h1>
              <div className="download" style={{ marginTop: -20 }} onClick={() => this.props.history.push('/export_list')}>
                <span>Free Download</span>
                <div style={{ color: "#20a8d8", cursor: "pointer" }} /*onClick={this.checkMonthlyDownloadLimit}*/>
                  <Link className='exportBtn' key={'export_list'} to={exportlistImg}><i className='fa fa-arrow-circle-up '></i>Export List</Link>

                </div>
                {/* <LazyLoad>
                  <img src={exportlistImg} />
                </LazyLoad> */}
              </div>
            </div>
          </CardHeader>
          <CardBody>
            <EnhancedTable city={city} cityPageData={this.state.cityPageData} data={this.context || []} /></CardBody>
        </Card>
      </div>
    );
  }
}

Home.contextType = AppContext;
export default Home;




// WEBPACK FOOTER //
// ./client/src/views/Home/city.js